<script lang="ts">
  import TextNew from "../TextNew.svelte";
  import Card from "../data-display/Card.svelte";
  import OverviewCardSkeleton from "../skeletons/OverviewCardSkeleton.svelte";

  export let isLoading = false;
  export let variant: "net" | "gross" | "vat" | "tax";
  export let total: string | undefined;
  export let invoiceTotal: string | undefined;
  export let creditNoteTotal: string | undefined;
</script>

<Card --card-minH="86px">
  {#if isLoading}
    <OverviewCardSkeleton />
  {:else}
    <div class="header">
      <TextNew size="s" font="ocr" --rk-text-color="var(--rekki-neutral-03)"
        >total {variant}</TextNew
      >
    </div>
    <div class="body">
      <div>
        <TextNew size="l">{total}</TextNew>
      </div>
      <div>
        <div class="labeled">
          <TextNew size="xs" tabular --rk-text-color="var(--rekki-neutral-03)">
            invoice {variant}
          </TextNew>
          <TextNew size="xs" tabular>{invoiceTotal}</TextNew>
        </div>
        <div class="labeled">
          <TextNew size="xs" tabular --rk-text-color="var(--rekki-neutral-03)">
            credit note {variant}
          </TextNew>
          <TextNew size="xs" tabular>{creditNoteTotal}</TextNew>
        </div>
      </div>
    </div>
  {/if}
</Card>

<style>
  .header {
    padding-bottom: 16px;
  }

  .labeled {
    display: flex;
    justify-content: space-between;
    gap: 4px;
  }

  .body {
    display: flex;
    justify-content: space-between;
  }
</style>
